import {EntityFactory, Reducer} from '@modifi/redux'
import {clientConfig} from '@modifi/client-config'
import {serviceClient} from '../../lib/ownClient'

export type Response = {
  isBuildVersionMatching: boolean
}

const apiClient = serviceClient()

const {reducer, actions, selectors} = EntityFactory({
  actionNamePrefix: 'data/buildVersionMatch',
  rootSelector: state => state?.data?.buildVersionMatch,
  fetchRequest: (state, params: {buildVersion: string}): Promise<Response> =>
    apiClient.Version.buildVersionMatch({buildVersion: params?.buildVersion}).then(res =>
      res.data<Response>()
    ),
})

export default reducer as Reducer

export const aFetchBuildVersionMatch = (): any =>
  actions!.fetch({buildVersion: clientConfig.get('VERSION') as string})

export const {selectIsLoading} = selectors

export const selectIsBuildVersionMatching = (state: Record<string, any>): boolean =>
  !!selectors?.selectEntity(state)?.isBuildVersionMatching
